// Apply YAML from the Studio, in the Deliver group and the palette: plan first, then apply.
import { FileUpIcon } from "lucide-react";
import { registerCommand } from "../../app/registry/commands";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "apply",
  group: "deliver",
  labelKey: "apply.nav",
  icon: FileUpIcon,
  to: ({ params }) => (params.workspace ? routes.apply(params.workspace) : null),
  order: 20,
});
registerCommand({
  id: "apply",
  group: "palette.groups.actions",
  labelKey: "apply.command",
  icon: FileUpIcon,
  keywords: ["yaml", "plan", "upload", "appliquer"],
  to: ({ params }) => (params.workspace ? routes.apply(params.workspace) : null),
});
